import { UserPresenceRecord } from '../../PresenceRecord.js';
import { ExternerMitarbeiter } from '../../master-data-management/users/entities/ExternerMitarbeiter.js';
import { Student } from '../../master-data-management/users/entities/Student.js';
import { TemporaryUser } from '../../master-data-management/users/entities/TemporaryUser.js';

export function filterCourseRecords(search: string, records: UserPresenceRecord[] | undefined, guestUsers: boolean) {
  if (!records) {
    return [];
  }

  return records.filter(record => {
    if (!record.user) {
      return false;
    }

    const studentGuest = record.user instanceof Student ? record.user.guestAccount : false;
    const mitarbeiterGuest = record.user instanceof ExternerMitarbeiter ? record.user.guestAccount : false;
    const tempUserGuest = !!(record.user instanceof TemporaryUser);
    const anyGuest = studentGuest || mitarbeiterGuest || tempUserGuest;

    if (guestUsers && !anyGuest) {
      return false;
    }
    if (!guestUsers && anyGuest) {
      return false;
    }
    if (search === '') {
      return true;
    }

    const inFirstname = (record.user.vorname ?? '').toLocaleLowerCase().includes(search.toLocaleLowerCase());
    const inSurname = (record.user.nachname ?? '').toLocaleLowerCase().includes(search.toLocaleLowerCase());
    return inFirstname || inSurname;
  });
}
